import React, { useEffect, useState } from 'react'
import {
    Box,
    Tabs,
    Tab,
    Card,
    Typography,
    Grid,
    Stack,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    TextField,
    IconButton,
    Paper,
    Pagination,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import Modal from "react-modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';
import { getApi, postApi, putApi } from '../../services/axiosInstance';
import { API_PATH } from '../../services/apipath';
import { toast } from 'react-toastify';

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        zIndex: "999",
        width: "350px",
    },
};

const EditQuestions = ({
    subCategory,
    selectedCategory,
    choices,
    setChoices,
    handleChoiceChange,
    toggleCorrectChoice,
    handleAddChoice,
    handleRemoveChoice,
    vipOptions,
    planTypeOptions,
    difficultyOptions,
    handleAddFillup,
    handleDelete
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [questionTitle, setQuestionTitle] = useState("");
    const [answer, setAnswer] = useState(" ");
    const [questionId, setQuestionId] = useState("");
    const [audioText, setAudioText] = useState(" ");
    const [questionText, setQuestionText] = useState("  ");
    const [difficultyLevel, setDifficultyLevel] = useState(null);
    const [longTextQuestion, setLongTextQuestion] = useState(" ");
    const [image, setImage] = useState(null);
    const [planType, setPlanType] = useState(null);
    const [keyWords, setKeyWords] = useState([]);
    const [mcqAns, setmcqAns] = useState([]);
    const [fillintheBlanks, setfillintheBlanks] = useState([]);
    const [vip, setVip] = useState(null);
    const [rwfillups, setRwfillups] = useState([
        { options: ["", "", "", ""], answer: "" },
    ]);

    const [questions, setQuestions] = useState([]);
    const [questionsTotal, setQuestionsTotal] = useState("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);



    // <====================correct answer ================>
    const [correctAnswer, setCorrectAnswer] = useState([0, 0, 0, 0]);

    const handleCorrectAnswerChange = (index, value) => {
        const numericValue = parseInt(value, 10);
        setCorrectAnswer((prev) =>
            prev.map((answer, i) => (i === index ? numericValue || 0 : answer))
        );
    };

    const handleAddCorrectAnswer = () => {
        setCorrectAnswer((prev) => [...prev, 0]);
    };

    const handleRemoveCorrectAnswer = (index) => {
        setCorrectAnswer((prev) => prev.filter((_, i) => i !== index));
    };


    // Update an option in a specific fillup
    const handleOptionChange = (fillupIndex, optionIndex, value) => {
        setRwfillups((prev) =>
            prev.map((fillup, i) =>
                i === fillupIndex
                    ? {
                        ...fillup,
                        options: fillup.options.map((option, j) =>
                            j === optionIndex ? value : option
                        ),
                    }
                    : fillup
            )
        );
    };

    // Update the answer in a specific fillup
    const handleAnswerChange = (fillupIndex, value) => {
        setRwfillups((prev) =>
            prev.map((fillup, i) =>
                i === fillupIndex ? { ...fillup, answer: value } : fillup
            )
        );
    };

    // Remove a specific fillup
    const handleRemoveFillup = (fillupIndex) => {
        setRwfillups((prev) => prev.filter((_, i) => i !== fillupIndex));
    };

    const rwF = rwfillups.map((fillup) => fillup.options);
    const rwF_ans = rwfillups.map((fillup) => fillup.answer);
    const fetchRequests = async () => {
        setIsLoading(true)
        try {
            const res = await postApi(API_PATH.SUPER_ADMIN.REQUEST_DELETE_LIST, {
                category: selectedCategory,
                subcategory: subCategory,
            });
            if (res.status === 200) {
                setQuestions(res.data.data.questions);
                setQuestionsTotal(res.data.data.totalQuestions);
            }
        } catch (error) { }
        setIsLoading(false)
    };

    const getQuestionDetails = async () => {
        setIsLoading(true)
        try {
            const res = await getApi(`${API_PATH.SUPER_ADMIN.GET_QUESTION_BY_ID}/${questionId}`)
            if (res.status === 200) {
                // Set question data
                setQuestionFields(res.data.data);
                console.log(res.data.data)
            }
        } catch (error) {
            console.error("Error fetching question:", error);
        }
        setIsLoading(false)
    }


    const setQuestionFields = (data) => {
        setAudioText(data.audio_text);
        setQuestionTitle(data.question_title);
        setQuestionText(data.question_text);
        setDifficultyLevel(data.difficulty_level);
        setPlanType(data.planType);
        setVip(data.vip);
        setAnswer(data.answer);
        setKeyWords(data.keyWords);
        setChoices(data.choices);
        setCorrectAnswer(data?.correct_order);
        setmcqAns(data.mcq_ans);
        setfillintheBlanks(data.FillInTheBlanksAnswers);
        setLongTextQuestion(data?.long_text_paragraph);
    }



    const openDeleteModal = () => {
        console.log("Delete modal triggered!");
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    // <====================correct answer close======================>

    const handleSubmitReadAloud = async () => {
        setIsLoading(true)
        try {
            let payload = {
                audio_text: audioText,
                question_title: questionTitle,
                question_type: selectedCategory,
                choices: choices,
                difficulty_level: difficultyLevel,
                vip: vip,
                module_type: [selectedCategory],
                module_subcategory: [subCategory],
                planType: String(planType),
            };
            if (
                selectedCategory === "Speaking" ||
                selectedCategory === "Writing" ||
                selectedCategory === "Reading" ||
                selectedCategory === "Listening"
            ) {
                payload.question_text = questionText;
            }

            if (
                selectedCategory === "Speaking" ||
                (selectedCategory === "Listening" &&
                    subCategory !== "Fill in The Blanks")
            ) {
                payload.audio_text = audioText;
            }
            if (
                (selectedCategory === "Speaking" &&
                    subCategory !== "Read Aloud") ||
                selectedCategory === "Writing" ||
                (selectedCategory === "Listening" &&
                    subCategory === "Write From Dictation") ||
                subCategory === "Summarize Text"
            ) {
                payload.answer = answer;
            }

            if (
                selectedCategory &&
                (subCategory === "Describe Image" ||
                    subCategory === "Essay" ||
                    subCategory === "Retell Lecture" ||
                    subCategory === "Respond to Situation" ||
                    subCategory === "Summarize Text" ||
                    selectedCategory === "Writing" ||
                    subCategory === "Summarize Text")
            ) {
                payload.keyWords = keyWords;
            }

            if (subCategory === "Missing Words") {
                payload.correct_order = correctAnswer;
            }

            if (selectedCategory && subCategory === "Incorrect Words") {
                payload.mcq_ans = mcqAns;
            }

            if (
                (selectedCategory === "Listening" &&
                    subCategory === "Fill in The Blanks") ||
                (selectedCategory === "Reading" &&
                    subCategory === "Fill in Blanks")
            ) {
                payload.FillInTheBlanksAnswers = fillintheBlanks;
            }

            if (
                selectedCategory === "Reading" &&
                (subCategory === "Single Answer" ||
                    subCategory === "Multiple Answers")
            ) {
                payload.long_text_paragraph = longTextQuestion;
            }

            if (selectedCategory && subCategory === "Reorder Paragraph") {
                payload.correct_order = correctAnswer;
            }

            if (selectedCategory && subCategory === "RW Fill in Blanks") {
                payload.rwF = rwF;
                payload.rwF_ans = rwF_ans;
            }
            const res = await putApi(`${API_PATH.SUPER_ADMIN.UPDATE_QUESTION}/${questionId}`, payload);

            if (res.status) {
                toast.success("Question Updated Successfully");
                console.log("Question Updated Successfully");

                if (selectedCategory && subCategory === "Describe Image") {
                    const formData = new FormData();
                    formData.append("image", image);
                    formData.append("questionId", questionId);
                    const resImage = await postApi(
                        API_PATH.SUPER_ADMIN.UPLOAD_IMAGE,
                        formData
                    );
                    console.log(resImage);
                }
                setQuestionId('')
                fetchRequests()
            }
        } catch (error) {
            toast.error("Question Not Updated");
            console.error("Error submitting question:", error);
        }
        setIsLoading(false)
    };
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // Calculate total pages
    const totalPages = Math.ceil(questionsTotal / itemsPerPage);

    // Calculate the range of items to be displayed
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Slice the data for current page
    const currentItems = questions.slice(startIndex, endIndex);

    // Function to change the current page
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    // Function to handle change in items per page
    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page when items per page changes
    };

    useEffect(() => {
        setQuestionId("")
        if (selectedCategory && subCategory) {
            fetchRequests();
        }
    }, [selectedCategory, subCategory]);
    useEffect(() => {
        console.log(questionId, "opopop")
        if (questionId) {
            getQuestionDetails();
        }
    }, [questionId]);


    return (
        <Box sx={{ overflow: "hidden" }}>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {!questionId && <React.Fragment>
                <div className="d-flex align-items-center justify-content-between my-4">
                    <h5 className="text-dark">
                        Total Questions : {questionsTotal}
                    </h5>
                    <div className="mr-3">
                        <FormControl sx={{ color: "black", width: "105px" }}>
                            <InputLabel sx={{ color: "black" }}>Items per page</InputLabel>
                            <Select
                                sx={{ color: "black", background: '#E1E1E1' }}
                                borderColor='black'
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                                label="Items per page"
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>

                {currentItems.map((question, index) => (
                    <Grid
                        key={index}
                        container
                        alignItems="center"
                        spacing={0}
                        sx={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            marginY: "14px",
                            padding: "10px",
                        }}
                    >
                        {/* Name and Domain */}
                        <Grid
                            item
                            xs={12}
                            sm={10}
                            md={10}
                            display="flex"
                            alignItems="center"
                        >
                            <Box>
                                <div style={{ color: "black", fontSize: "15px" }}>
                                    {index + 1}. {question.question_text ? `${question.title} ${question.question_text}` : question.id}
                                </div>
                            </Box>
                        </Grid>

                        {/* Actions (Delete Button) */}
                        <Grid
                            item
                            xs={12}
                            sm={3}
                            md={2}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Button
                                sx={{
                                    // borderColor: "#f10f0f",
                                    // color: "green",
                                    // "&:hover": {
                                    //     borderColor: "#bc3232",
                                    //     color: "#bc3232",
                                    // },
                                }}
                                variant="outlined"
                                startIcon={<EditIcon />}
                                onClick={() => {
                                    setQuestionId(question.id);
                                }}
                            >
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                ))}

                <Box
                    sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                        bgcolor: "#1a1a2e",
                    }}
                >
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        shape="rounded"
                        showFirstButton
                        showLastButton
                    />
                </Box>
            </React.Fragment>}

            {/* Modal */}
            <Modal
                ariaHideApp={false}
                isOpen={isDeleteModalOpen}
                style={customStyles}
                onClose={closeDeleteModal}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
            >
                <Box
                    sx={{
                        color: "black",
                    }}
                >
                    <Typography
                        id="delete-modal-title"
                        variant="h6"
                        component="h2"
                        gutterBottom
                    >
                        Are you sure?
                    </Typography>
                    <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                        Do you want to delete this item?
                    </Typography>
                    <Box display="flex" gap={2}>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleDelete}
                        >
                            Yes, Delete
                        </Button>
                        <Button variant="outlined" onClick={closeDeleteModal}>
                            No, Cancel
                        </Button>
                    </Box>
                </Box>
            </Modal>


            {questionId &&
                <Box sx={{ marginTop: "20px" }}>
                    {/* Question Title */}
                    <label style={{ color: "black" }}>Question Title</label>
                    <input
                        type="text"
                        value={questionTitle}
                        onChange={(e) => setQuestionTitle(e.target.value)}
                        style={{ width: "100%", padding: "8px", margin: "10px 0" }}
                    />

                    {/* Audio Text */}
                    {/* { (subCategory === "Read Aloud" || subCategory === "Repeat Sentence" || subCategory === "Short Answer" || subCategory === "Retell Lecture" || subCategory === "Respond Situation" || subCategory === "Single Answer" || subCategory === "Multiple Answers" || subCategory === "Write From Dictation" || subCategory === "Highlight Summary" || subCategory === "Summarize Text" || subCategory === "Missing Word" || subCategory === "Incorrect Words" || subCategory === "Fill in The Blanks") && (
                <>
                  <label style={{ color: "black" }}>Audio Text</label>
                  <input
                    type="text"
                    value={audioText}
                    onChange={(e) => setAudioText(e.target.value)}
                    style={{ width: "100%", padding: "8px", margin: "10px 0" }}
                  />
                </>
              )} */}

                    {selectedCategory === "Speaking" ||
                        selectedCategory === "Listening" ? (
                        <>
                            <label style={{ color: "black" }}>Audio Text</label>
                            <input
                                type="text"
                                value={audioText}
                                onChange={(e) => setAudioText(e.target.value)}
                                style={{ width: "100%", padding: "8px", margin: "10px 0" }}
                            />
                        </>
                    ) : (
                        ""
                    )}

                    {/* Question Text */}
                    {/* { (subCategory === "Read Aloud" || subCategory === "Repeat Sentence" || subCategory === "Respond Situation" || subCategory === "Single Answer" || subCategory === "Multiple Answers" || subCategory === "Essay" || subCategory === "Writing Summarize Text" || subCategory === "Write Email" || subCategory === "Single Answer" || subCategory === "Multiple Answers" || subCategory === "Highlight Summary" || subCategory === "Incorrect Words" || subCategory === "Fill in The Blanks" || subCategory === "RW Fill in Blanks") && (
                <>
                  <label style={{ color: "black" }}>Question Text</label>
                  <input
                    type="text"
                    value={questionText}
                    onChange={(e) => setQuestionText(e.target.value)}
                    style={{ width: "100%", padding: "8px", margin: "10px 0" }}
                  />
                </>
              )} */}

                    {(selectedCategory === "Speaking" &&
                        subCategory !== "Repeat Sentence" &&
                        subCategory !== "Retell Lecture" &&
                        subCategory !== "Short Answer" &&
                        subCategory !== "Describe Image") ||
                        selectedCategory === "Writing" ||
                        (selectedCategory === "Reading" &&
                            subCategory !== "Reorder Paragraph") ||
                        (selectedCategory === "Listening" &&
                            subCategory === "Single Answer") ||
                        subCategory === "Multiple Answers" ||
                        subCategory === "Fill in The Blanks" ||
                        subCategory === "Incorrect Words" ? (
                        <>
                            <label style={{ color: "black" }}>Question Text</label>
                            <input
                                type="text"
                                value={questionText}
                                onChange={(e) => setQuestionText(e.target.value)}
                                style={{ width: "100%", padding: "8px", margin: "10px 0" }}
                            />
                        </>
                    ) : (
                        ""
                    )}

                    {/* Answer Text */}
                    {/* { (subCategory === "Repeat Sentence" || subCategory === "Short Answer" || subCategory === "Retell Lecture" || subCategory === "Respond Situation" || subCategory === "Summarize Text" || subCategory === "Essay" || subCategory === "Writing Summarize Text" || subCategory === "Write Email" || subCategory === "Describe Image" || subCategory === "Write From Dictation") && (
                <> 
                  <label style={{ color: "black" }}>Answer1</label>
                  <input
                    type="text"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    style={{ width: "100%", padding: "8px", margin: "10px 0", color: "black" }}
                  />
                </>
              )} */}

                    <br />
                    {((selectedCategory === "Reading" &&
                        subCategory === "Single Answer") ||
                        (selectedCategory === "Reading" &&
                            subCategory === "Multiple Answers")) && (
                            <>
                                <label style={{ color: "black", marginTop: "10px" }}>
                                    Long Text Question
                                </label>
                                <textarea
                                    value={longTextQuestion}
                                    onChange={(e) => setLongTextQuestion(e.target.value)}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        margin: "10px 0",
                                        color: "black",
                                        height: "120px",
                                    }}
                                />
                            </>
                        )}
                    {(selectedCategory === "Speaking" &&
                        subCategory !== "Read Aloud") ||
                        selectedCategory === "Writing" ||
                        (selectedCategory === "Listening" &&
                            (subCategory === "Write From Dictation" ||
                                subCategory === "Summarize Text")) ? (
                        <>
                            <label style={{ color: "black" }}>Answer</label>
                            <textarea
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    margin: "10px 0",
                                    color: "black",
                                    minHeight: "100px",
                                    resize: "vertical",
                                }}
                            />
                        </>
                    ) : (
                        ""
                    )}

                    {
                        (subCategory === "Describe Image" ||
                            subCategory === "Retell Lecture" ||
                            subCategory === "Respond to Situation" ||
                            subCategory === "Summarize Text" ||
                            selectedCategory === "Writing" ||
                            subCategory === "Summarize Text" ||
                            subCategory === "Write Email" ||
                            subCategory === "Essay") && (
                            <>
                                <label style={{ color: "black" }}>Keywords</label>
                                <input
                                    type="text"
                                    value={keyWords?.join(", ")}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        const formattedKeywords = input
                                            .split(",")
                                            .map((item) => item.trim());
                                        setKeyWords(formattedKeywords);
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        margin: "10px 0",
                                        color: "black",
                                    }}
                                />
                            </>
                        )}

                    {/* Correct Text */}
                    {
                        subCategory === "Incorrect Words" && (
                            <>
                                <label style={{ color: "black" }}>Correct Words</label>
                                <input
                                    type="text"
                                    value={mcqAns.join(", ")}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        const formattedKeywords = input
                                            .split(",")
                                            .map((item) => item.trim());
                                        setmcqAns(formattedKeywords);
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        margin: "10px 0",
                                        color: "black",
                                    }}
                                />
                            </>
                        )}

                    {/* Fill in The Blanks Answer Text */}
                    {selectedCategory === "Listening" &&
                        subCategory === "Fill in The Blanks" || selectedCategory == "Reading" &&
                        subCategory === "Fill in Blanks" && (
                            <>
                                <label style={{ color: "black" }}>
                                    Fill in The Blanks Answer
                                </label>
                                <input
                                    type="text"
                                    value={fillintheBlanks.join(", ")}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        const formattedKeywords = input
                                            .split(",")
                                            .map((item) => item.trim());
                                        setfillintheBlanks(formattedKeywords);
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        margin: "10px 0",
                                        color: "black",
                                    }}
                                />
                            </>
                        )}

                    {/* Choices Input */}
                    {
                        (subCategory === "Single Answer" ||
                            subCategory === "Multiple Answers" ||
                            subCategory === "Highlight Summary" ||
                            subCategory === "Missing Word" ||
                            subCategory === "Reorder Paragraph" ||
                            subCategory === "Fill in Blanks") && (
                            <>
                                <Typography variant="h6" sx={{ color: "black" }}>
                                    Choices
                                </Typography>
                                {choices.map((choice, index) => (
                                    <Stack
                                        key={index}
                                        direction="row"
                                        alignItems="center"
                                        spacing={2}
                                        mt={2}
                                    >
                                        {/* Choice Text Input */}
                                        <TextField
                                            fullWidth
                                            value={choice.choice_text}
                                            onChange={(e) =>
                                                handleChoiceChange(index, e.target.value)
                                            }
                                            placeholder={`Choice ${index + 1}`}
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": { borderColor: "black" },
                                                    "&:hover fieldset": { borderColor: "black" },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "black",
                                                    },
                                                },
                                                // Set the input text color to black
                                                "& .MuiInputBase-input": {
                                                    color: "black", // Text color inside the input field
                                                },
                                                // Set the placeholder color to black
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black", // Placeholder text color
                                                },
                                            }}
                                        />

                                        {/* Toggle Correct Button */}
                                        <Button
                                            variant={choice.is_correct ? "contained" : "outlined"}
                                            color="success"
                                            onClick={() => toggleCorrectChoice(index)}
                                        >
                                            {choice.is_correct ? " Correct " : " Correct"}
                                        </Button>

                                        {/* Remove Choice Button */}
                                        <IconButton
                                            color="error"
                                            onClick={() => handleRemoveChoice(index)}
                                            disabled={choices.length <= 1}
                                        >
                                            <RemoveCircleIcon />
                                        </IconButton>
                                    </Stack>
                                ))}

                                {/* Add Choice Button */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddChoice}
                                    startIcon={<AddCircleIcon />}
                                    sx={{ mt: 2 }}
                                >
                                    Add Choice
                                </Button>
                            </>
                        )}

                    {/* Correct Input */}
                    {
                        subCategory === "Reorder Paragraph" && (
                            <>
                                <Typography variant="h6" sx={{ color: "black" }}>
                                    Correct Answers
                                </Typography>

                                {correctAnswer.map((answer, index) => (
                                    <Stack
                                        key={index}
                                        direction="row"
                                        alignItems="center"
                                        spacing={2}
                                        mt={2}
                                    >
                                        {/* Correct Answer Text Input */}
                                        <TextField
                                            type="number"
                                            fullWidth
                                            value={answer}
                                            onChange={(e) =>
                                                handleCorrectAnswerChange(index, e.target.value)
                                            }
                                            placeholder={`Answer ${index + 1}`}
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": { borderColor: "black" },
                                                    "&:hover fieldset": { borderColor: "black" },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "black",
                                                    },
                                                },
                                                "& .MuiInputBase-input": {
                                                    color: "black",
                                                },
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black",
                                                },
                                            }}
                                        />

                                        {/* Remove Correct Answer Button */}
                                        <IconButton
                                            color="error"
                                            onClick={() => handleRemoveCorrectAnswer(index)}
                                            disabled={correctAnswer.length <= 1}
                                        >
                                            <RemoveCircleIcon />
                                        </IconButton>
                                    </Stack>
                                ))}

                                {/* Add Correct Answer Button */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddCorrectAnswer}
                                    startIcon={<AddCircleIcon />}
                                    sx={{ mt: 2 }}
                                >
                                    Add Answer
                                </Button>
                            </>
                        )}

                    {/* R/W Fill in the Blanks */}
                    {
                        subCategory === "RW Fill in Blanks" && (
                            <>
                                <Typography variant="h6" sx={{ color: "black" }}>
                                    R/W Fill in the Blanks
                                </Typography>

                                {rwfillups.map((fillup, fillupIndex) => (
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={2}
                                        mt={2}
                                        key={fillupIndex}
                                    >
                                        {/* Options Text Fields */}
                                        {fillup.options.map((option, optionIndex) => (
                                            <TextField
                                                key={optionIndex}
                                                fullWidth
                                                value={option || ""}
                                                onChange={(e) =>
                                                    handleOptionChange(
                                                        fillupIndex,
                                                        optionIndex,
                                                        e.target.value
                                                    )
                                                }
                                                placeholder={`Option ${optionIndex + 1}`}
                                                variant="outlined"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": { borderColor: "black" },
                                                        "&:hover fieldset": { borderColor: "black" },
                                                        "&.Mui-focused fieldset": {
                                                            borderColor: "black",
                                                        },
                                                    },
                                                    "& .MuiInputBase-input": { color: "black" },
                                                    "& .MuiInputBase-input::placeholder": {
                                                        color: "black",
                                                    },
                                                }}
                                            />
                                        ))}

                                        {/* Answer Text Field */}
                                        <TextField
                                            fullWidth
                                            value={fillup.answer || ""}
                                            onChange={(e) =>
                                                handleAnswerChange(fillupIndex, e.target.value)
                                            }
                                            placeholder="Answer"
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": { borderColor: "black" },
                                                    "&:hover fieldset": { borderColor: "black" },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "black",
                                                    },
                                                },
                                                "& .MuiInputBase-input": { color: "black" },
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black",
                                                },
                                            }}
                                        />

                                        {/* Remove Fillup Button */}
                                        <IconButton
                                            color="error"
                                            onClick={() => handleRemoveFillup(fillupIndex)}
                                        >
                                            <RemoveCircleIcon />
                                        </IconButton>
                                    </Stack>
                                ))}

                                {/* Add Fillup Button */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddFillup}
                                    startIcon={<AddCircleIcon />}
                                    sx={{ mt: 2 }}
                                >
                                    Add Fillup
                                </Button>

                                {/* Display Data for Backend */}
                                {/* <Typography variant="body1" sx={{ mt: 4 }}>
                    <strong>rwF:</strong> {JSON.stringify(rwF)}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 2 }}>
                    <strong>rwF_ans:</strong> {JSON.stringify(rwF_ans)}
                  </Typography> */}
                            </>
                        )}

                    <br />
                    {/* Difficulty Level Dropdown */}
                    <label style={{ color: "black", marginTop: "10px" }}>Difficulty Level</label>
                    <Select
                        value={difficultyLevel}
                        onChange={(e) => setDifficultyLevel(e.target.value)}
                        displayEmpty
                        fullWidth
                        sx={{
                            margin: "10px 0",
                            color: "black",
                            border: "1px black solid",
                            height: "40px",
                        }}
                        inputProps={{
                            style: {
                                color: "black",
                                borderColor: "black",
                            },
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                            },
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select Difficulty Level
                        </MenuItem>
                        {difficultyOptions.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                sx={{ color: "black" }}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>

                    {/* Plan Type Dropdown */}
                    <label style={{ color: "black" }}>Plan Type</label>
                    <Select
                        value={planType}
                        onChange={(e) => setPlanType(e.target.value)}
                        displayEmpty
                        fullWidth
                        sx={{
                            margin: "10px 0",
                            color: "black",
                            border: "1px black solid",
                            height: "40px",
                        }}
                        inputProps={{
                            style: {
                                color: "black",
                                borderColor: "black",
                            },
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                            },
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select Plan Type
                        </MenuItem>
                        {planTypeOptions.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                sx={{ color: "black" }}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>

                    {/* VIP Dropdown */}
                    <label style={{ color: "black" }}>VIP</label>
                    <Select
                        value={vip}
                        onChange={(e) => setVip(e.target.value)}
                        displayEmpty
                        fullWidth
                        sx={{
                            margin: "10px 0",
                            color: "black",
                            border: "1px black solid",
                            height: "40px",
                        }}
                        inputProps={{
                            style: {
                                color: "black",
                                borderColor: "black",
                            },
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                            },
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select VIP
                        </MenuItem>
                        {vipOptions.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                sx={{ color: "black" }}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>

                    {subCategory === "Describe Image" && (
                        <>
                            <label style={{ color: "black", margin: "40px 0 10px 0" }}>
                                Upload Image
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => setImage(e.target.files[0])}
                                style={{ margin: "10px 0 0px 8px" }}
                                className="text-dark"
                            />
                            <br />
                            {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitImage}
                    sx={{ marginTop: "20px" }}
                  >
                    Submit
                  </Button> */}
                        </>
                    )}

                    {/* Submit Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitReadAloud}
                        sx={{ marginTop: "20px" }}
                    >
                        Submit
                    </Button>

                    <br />
                    {/* Image Upload */}
                </Box>
            }
        </Box>
    )
}

export default EditQuestions